import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { AlertSeverityEnum, PROVEEDOR,  ProveedorPagingRes, UseMutationsParams } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';



const { get, post, put } = erpApi();

///* tanSctack query
export const usefetchProveedor = (params?: GetProveedorParams) => {
  return useQuery({
    queryKey: ['proveedor', ...Object.values(params ?? {})],
    queryFn: async () => {
      return getProveedores(params);
    },
  });
};

export const useGetProveedor = (id: string) => {
  return useQuery({
    queryKey: ['proveedor', id],
    queryFn: async () => {
      return getProveedor(id);
    },
  });
};

export const useCreateProveedor = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createProveedores,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['proveedor'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Proveedor creado correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const useUpdateProveedor = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: updateProveedor,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['proveedor'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Proveedor actualizado correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

///* axios
export type GetProveedorParams = Partial<PROVEEDOR> & {
  page?: number;
  page_size?: number;
}

export type CreateProveedorParams = Omit<PROVEEDOR, 'id_proveedor'>;
export type UpdateProveedorParams = {
  id: string;
  data: Omit<PROVEEDOR, 'id_proveedor'>;
};

export const getProveedores = async (params?: GetProveedorParams) => {
  const queryParams = getUrlParamsFetch({ ...params });

  return get<ProveedorPagingRes>(
    `${urlBackend}api/v1/proveedor/?${queryParams}`,
    true
  );
};

export const getProveedor = async (id: string) => {
  try {
    return await get<PROVEEDOR>(`${urlBackend}api/v1/proveedor/${id}/`, true);
  }
  catch (error) {
    handleAxiosError(error);
  }
};

export const createProveedores = async (data: CreateProveedorParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return post<PROVEEDOR>(`${urlBackend}api/v1/proveedor/`, data, true);
};

export const updateProveedor = async ({ id, data }: UpdateProveedorParams) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return put<PROVEEDOR>(`${urlBackend}api/v1/proveedor/${id}/`, data, true);
};


/// Importar Excel proveedor

export const useCreateProveedorUploadExcel = () => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createProveedorUploadExcel,
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['proveedor'] });

      
      if (data.code == 200)
        setAlert(true, data.message, data.status);

    },
    onError: error => {
      handleAxiosError(error);
    },
  });
};

//FormData
export const createProveedorUploadExcel = async (data: { url: string }) => {
  
  const res = await post<PROVEEDOR>(`${urlBackend}api/v1/subir-excel-crear-proveedores/`, data, true, true);
  return res;
};

export type SeriesProveedor = {
  producto: string;
  movimiento_inventario: string;
}

export const getSerieByProveedor = async (params: SeriesProveedor) => {

  const queryParams = getUrlParamsFetch(params || {});

  return await get<SeriesProveedor>(`${urlBackend}api/v1/obtener-proveedor-serie/?${queryParams}`, true)
}